import React from "react";
import styled from "styled-components";
import {media} from "../../../../theme/responsive";
import {
    loaderanimationRule,
    LoaderCard,
    LoaderCardContent,
    LoaderDiv,
    LoaderHeading,
    LoaderMainContainer,
    LoaderSectionContainer,
} from "../../../CommonContentLoaderStyled/widgets/Styled";
import PropTypes from "prop-types";
import {Smoke} from "../../../../theme/variable";

const LoaderReviewContainer = styled.div`
    width: 100%;
    display: table;
    padding: 12px;
    ${media.laptop`padding:16px;`}
`;

const LoaderReviewBox = styled.div`
    display: block;
    vertical-align: top;
    text-align: center;
    span.width25 {
        height: 30px;
        background: #e9e9e9;
        animation: ${loaderanimationRule};
        display: block;
        margin-bottom: 5px;
        width: 100px;
        &:first-child,
        &:last-child {
            height: 14px;
        }
        ${media.laptop`width:60%;`}
    }
    &:first-child {
        padding-left: 40%;
        margin-bottom: 15px;
        ${media.laptop` width:25%;padding-left:135px;margin-bottom:0;`}
    }
    &:last-child {
        width: 100%;
        ${media.laptop`width:75%;`}
    }
    ${media.laptop`display:table-cell;`}
`;
const LoaderRatingInfo = styled.div`
    width: 100%;
`;
const LoaderRating = styled.div`
    width: 49%;
    padding-left: 10px;
    display: inline-block;
    vertical-align: top;
    &:first-child {
        ${media.laptop`border-right:1px solid ${Smoke};`}
    }
    span {
        height: 14px;
        background: #e9e9e9;
        animation: ${loaderanimationRule};
        display: block;
        width: 100%;
        margin-bottom: 5px;
        ${media.laptop` width:75%;`}
    }
    span.spaceAbove {
        margin-top: 30px;
    }
    span.spaceAbove15 {
        margin-top: 15px;
    }
    ${media.laptop`padding-left:50px;width:45%`}
`;
const LoaderReviewCTA = styled.div`
    border-top: 1px solid ${Smoke};
    width: 100%;
    padding: 12px;
    ${media.laptop`padding:16px;`}
`;
const LoaderReviewCTALeft = styled.div`
    display: block;
    width: 100%;
    span {
        height: 14px;
        background: #e9e9e9;
        animation: ${loaderanimationRule};
        display: block;
        width: 100%;
        margin-bottom: 5px;
    }
    span.width75 {
        width: 75%;
        margin-bottom: 0;
    }
    ${media.laptop`width:50%;display:inline-block;`}
`;
const LoaderReviewCTARight = styled.div`
    width: 100%;
    display: block;
    margin-top: 15px;
    > div {
        background: #e9e9e9;
        animation: ${loaderanimationRule};
        width: 130px;
        height: 36px;
        display: block;
        margin: 0 auto;
        &:last-child {
            width: 250px;
            margin-top: 10px;
            ${media.laptop`margin-left:10px;`}
        }
        ${media.laptop`display:inline-block;`}
    }
    ${media.laptop`width:50%;display:inline-block;margin-top:0;text-align:right;`}
`;
const LoaderSorting = styled.div`
    width: 100%;
    display: table;
    border-top: 1px solid ${Smoke};
    label {
        border-right: 1px solid ${Smoke};
        display: table-cell;
        width: 60px;
        text-align: center;
        font-size: 0.875rem;
        vertical-align: middle;
        ${media.laptop`width:100px`}
        span {
            background: #e9e9e9;
            animation: ${loaderanimationRule};
            height: 14px;
            width: 20px;
            display: block;
            margin: 0 auto;
            ${media.laptop`width:60px;`}
        }
    }
`;
const LoaderReviewSortLabel = styled.div`
    display:table-cell;
    padding:10px 16px 10px 8px;
    position:relative;
    border-right:1px solid ${Smoke};
    text-align:center;
    vertical-align:middle;
    width:200px
    &:last-child{
        border-right:none;
    }
    span{
            background:#e9e9e9;
            animation: ${loaderanimationRule};
            height:14px;
            width:80%;
            display:block;
            margin:0 auto;
        }
`;
export const LoaderReviewProfile = styled.div`
    width: 100%;
    display: table;
    padding: 12px;
    border-bottom: 1px solid ${Smoke};
    ${media.laptop`padding:16px;`}
`;
export const LoaderReviewProfileSection = styled.div`
    display: table-cell;
    &:first-child {
        width: 100%;
        ${media.laptop`width:85%;`}
    }
    &:last-child {
        display: none;
        ${media.laptop`width:15%;vertical-align:top;display:table-cell;`}
    }
    span.reviewTag {
        background: #e9e9e9;
        animation: ${loaderanimationRule};
        width: 100px;
        height: 14px;
        display: block;
        float: right;
    }
`;
export const LoaderReviewUserImage = styled.div`
    width: 62px;
    height: 62px;
    border-radius: 50%;
    border: 1px solid ${Smoke};
    display: inline-block;
    vertical-align: middle;
    background: #e9e9e9;
    animation: ${loaderanimationRule};
    img {
        width: 62px;
        height: 62px;
    }
`;
export const LoaderReviewUserDetails = styled.div`
    margin-left: 16px;
    display: inline-block;
    vertical-align: middle;
    width: 80%;
    span {
        background: #e9e9e9;
        animation: ${loaderanimationRule};
        height: 14px;
        width: 40%;
        display: block;
        margin-bottom: 8px;
    }
    p {
        background: #e9e9e9;
        animation: ${loaderanimationRule};
        height: 14px;
        width: 60%;
        ${media.laptop`display:inline-block;
        margin-right:4px;`}
    }
`;
export const LoaderReviewContent = styled.div`
    padding: 12px;
    width: 100%;
    ${media.laptop`padding:16px;`}
    p {
        background: #e9e9e9;
        animation: ${loaderanimationRule};
        height: 14px;
        width: 60%;
        margin-bottom: 8px;
        &:first-child {
            width: 100%;
        }
        &:last-child {
            width: 35%;
        }
    }
`;

export const ReviewCardContentLoader = () => {
    return (
        <LoaderCard>
            <LoaderCardContent cardStyle={{mobile: {padding: "0"}, laptop: {padding: "0"}}}>
                <LoaderReviewProfile>
                    <LoaderReviewProfileSection>
                        <LoaderReviewUserImage />
                        <LoaderReviewUserDetails>
                            <span />
                            <p />
                        </LoaderReviewUserDetails>
                    </LoaderReviewProfileSection>
                    <LoaderReviewProfileSection>
                        <span className="reviewTag" />
                    </LoaderReviewProfileSection>
                </LoaderReviewProfile>
                <LoaderReviewContent>
                    <p />
                    <p />
                    <p />
                </LoaderReviewContent>
            </LoaderCardContent>
        </LoaderCard>
    );
};

export const ReviewContentLoader = () => {
    return (
        <LoaderDiv>
            <LoaderMainContainer
                loaderMainContainerStyle={{
                    mobile: {margin: ""},
                    laptop: {margin: "38px auto 0"},
                }}
            >
                <LoaderSectionContainer
                    loaderSectionContainerStyle={{
                        mobile: {maxWidth: ""},
                        laptop: {maxWidth: "970px"},
                    }}
                >
                    <LoaderCard>
                        <LoaderHeading>
                            <div />
                        </LoaderHeading>
                        <LoaderCardContent
                            cardStyle={{
                                mobile: {padding: "0"},
                                laptop: {padding: "0"},
                            }}
                        >
                            <LoaderReviewContainer>
                                <LoaderReviewBox>
                                    <span className="width25" />
                                    <span className="width25" />
                                    <span className="width25" />
                                </LoaderReviewBox>

                                <LoaderReviewBox>
                                    <LoaderRatingInfo>
                                        <LoaderRating>
                                            <span />
                                            <span />
                                            <span />
                                            <span />
                                            <span />
                                        </LoaderRating>
                                        <LoaderRating>
                                            <span />
                                            <span className="spaceAbove" />
                                            <span className="spaceAbove15" />
                                        </LoaderRating>
                                    </LoaderRatingInfo>
                                </LoaderReviewBox>
                            </LoaderReviewContainer>
                            <LoaderReviewCTA>
                                <LoaderReviewCTALeft>
                                    <span />
                                    <span className="width75" />
                                </LoaderReviewCTALeft>
                                <LoaderReviewCTARight>
                                    <div />
                                    <div />
                                </LoaderReviewCTARight>
                            </LoaderReviewCTA>
                            <LoaderSorting>
                                <label>
                                    <span />
                                </label>
                                <LoaderReviewSortLabel>
                                    <span />
                                </LoaderReviewSortLabel>
                                <LoaderReviewSortLabel>
                                    <span />
                                </LoaderReviewSortLabel>
                                <LoaderReviewSortLabel>
                                    <span />
                                </LoaderReviewSortLabel>
                            </LoaderSorting>
                        </LoaderCardContent>
                    </LoaderCard>
                    <LoaderCard>
                        <LoaderCardContent
                            cardStyle={{
                                mobile: {padding: "0"},
                                laptop: {padding: "0"},
                            }}
                        >
                            <LoaderReviewProfile>
                                <LoaderReviewProfileSection>
                                    <LoaderReviewUserImage />
                                    <LoaderReviewUserDetails>
                                        <span />
                                        <p />
                                    </LoaderReviewUserDetails>
                                </LoaderReviewProfileSection>
                                <LoaderReviewProfileSection>
                                    <span className="reviewTag" />
                                </LoaderReviewProfileSection>
                            </LoaderReviewProfile>
                            <LoaderReviewContent>
                                <p />
                                <p />
                                <p />
                            </LoaderReviewContent>
                        </LoaderCardContent>
                    </LoaderCard>
                </LoaderSectionContainer>
            </LoaderMainContainer>
        </LoaderDiv>
    );
};

ReviewContentLoader.propTypes = {
    style: PropTypes.object,
    cardStyle: PropTypes.object,
    headingStyle: PropTypes.object,
};
